import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import customInputComponent from '../../forms/customInputBronson';

function maskPhone(valueToMask) {
    const value = ('' + valueToMask).replace(/\D/g, '');
    const regex = /^(\d{3})(\d{3})(\d{4})$/;
    const updatedValue = regex.exec(value);
    if (updatedValue) {
        return '(' + updatedValue[1] + ') ' + updatedValue[2] + '-' + updatedValue[3];
    }
    return value;
}

function getValidationSchema() {
    return Yup.object().shape({
        firstName: Yup.string()
            //.required(i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR, { fieldName: "First Name" }))
            .matches(/^[a-zA-Z '-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR) })
            .max(40, i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR)),
        lastName: Yup.string()
            //.required(i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR, { fieldName: "Last Name" }))
            .matches(/^[a-zA-Z '-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR) })
            .max(40, i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR)),
        phone: Yup.string()
            //.required(i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
            .matches(/^\d*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR) })
            .min(10, i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
            .max(10, i18n.t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR)),
    });
}

const AgentFormEffect = ({ values, errors, handleAgentInfo }) => {
    useEffect(() => {
        handleAgentInfo({
            firstName: values.firstName,
            lastName: values.lastName,
            phone: values.phone,
            isValid: errors ? Object.keys(errors).length === 0 : true,
        });
        // eslint-disable-next-line
    }, [values.firstName, values.lastName, values.phone, JSON.stringify(errors)]);
    return null;
};

const AgentForm = ({ handleAgentInfo }) => {
    return (
        <div className="o-layout">
            <Formik
                initialValues={{
                    firstName: "",
                    lastName: "",
                    phone: "",
                }}
                validationSchema={getValidationSchema()}
            >
                {props => (
                    <>
                        <AgentFormEffect values={props.values} errors={props.errors} handleAgentInfo={handleAgentInfo} />
                        <Form>
                            <div className="o-layout row-container u-mt">
                                <div className="o-layout__item u-m-none">
                                    <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                                        <Field
                                            name="firstName"
                                            data-testid="firstName"
                                            placeHolder={i18n.t(rk.AGENT.FIRST_NAME)}
                                            altPlaceholder={(i18n.t(rk.AGENT.FIRST_NAME)).toUpperCase()}
                                            type="text"
                                            id="firstName"
                                            component={customInputComponent}
                                            error={Boolean(props.errors.firstName)}
                                            helpContent={props.errors.firstName}
                                            value={props.values.firstName}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                        />
                                    </div>
                                    <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                                        <Field
                                            name="lastName"
                                            data-testid="lastName"
                                            placeHolder={i18n.t(rk.AGENT.LAST_NAME)}
                                            altPlaceholder={(i18n.t(rk.AGENT.LAST_NAME)).toUpperCase()}
                                            type="text"
                                            id="lastName"
                                            component={customInputComponent}
                                            error={Boolean(props.errors.lastName)}
                                            helpContent={props.errors.lastName}
                                            value={props.values.lastName}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                        />
                                    </div>
                                </div>
                                <div className="o-layout__item u-m-none">
                                    <div className="o-layout__item u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                                        <Field
                                            name="phone"
                                            data-testid="phone"
                                            placeHolder={i18n.t(rk.AGENT.PHONE_NUMBER)}
                                            altPlaceholder={(i18n.t(rk.AGENT.PHONE_NUMBER)).toUpperCase()}
                                            type="text"
                                            id="phone"
                                            component={customInputComponent}
                                            error={Boolean(props.errors.phone)}
                                            helpContent={props.errors.phone}
                                            maxLength={10}
                                            value={props.values.phone}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            maskValue={maskPhone}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
};

AgentForm.propTypes = {
    handleAgentInfo: PropTypes.func,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
    errors: {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        phone: PropTypes.string,
    },
    values: {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        phone: PropTypes.string,
    }
};
AgentForm.defaultProps = {
    handleAgentInfo: () => {},
    handleBlur: () => {},
    handleChange: () => {},
    errors: {
        firstName: "",
        lastName: "",
        phone: "",
    },
    values: {
        firstName: "",
        lastName: "",
        phone: "",
    }
}

AgentFormEffect.propTypes = {
    values: {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        phone: PropTypes.string,
    },
    errors: PropTypes.object.isRequired,
    handleAgentInfo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(AgentForm));
